export default "__VITE_ASSET__b4ee7beb__"